import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const RiskAlert = ({ text, compact }) => (
  <div data-testid="risk-disclaimer" className={`flex gap-3 rounded-xl border border-[hsl(var(--brand-gold)/0.35)] bg-[hsl(var(--brand-gold)/0.12)] ${compact ? 'p-3' : 'p-4'}`}>
    <AlertTriangle className="h-5 w-5 flex-shrink-0 text-amber-600 mt-0.5" />
    <p className={`${compact ? 'text-xs' : 'text-sm'} leading-relaxed text-foreground/80`}>
      {text || 'Trading mengandung risiko. Contoh historis tidak menjamin hasil di masa depan. Materi ini bersifat edukasi, bukan nasihat keuangan/investasi.'}
    </p>
  </div>
);

export default RiskAlert;
